export const Coins = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="148"
      height="129"
      viewBox="0 0 148 129"
      fill="none"
    >
      <g clipPath="url(#clip0_571_2390)">
        <path
          d="M136.35 71.723C138.029 74.0242 139.702 76.331 141.382 78.6322C145.39 84.1423 146.151 91.9252 142.665 99.9683C136.74 113.649 120.779 122.894 107.02 120.626C101.348 119.692 96.9387 116.943 94.1249 113.082L89.0929 106.173C91.9067 110.033 96.3156 112.783 101.988 113.717C115.747 115.985 131.708 106.74 137.633 93.059C141.119 85.016 140.358 77.233 136.35 71.723Z"
          fill="url(#paint0_linear_571_2390)"
        />
        <path
          d="M123.454 64.1732C137.213 66.4413 143.564 79.373 137.632 93.0534C131.701 106.734 115.747 115.98 101.988 113.712C88.2235 111.436 81.8786 98.5117 87.8036 84.8306C93.7349 71.1502 109.695 61.9052 123.454 64.1732Z"
          fill="url(#paint1_linear_571_2390)"
        />
        <path
          d="M120.428 71.1452C130.311 72.7778 134.876 82.0612 130.618 91.8919C126.359 101.716 114.89 108.366 105.007 106.734C95.1186 105.1 90.56 95.8111 94.8181 85.9868C99.077 76.1562 110.54 69.5119 120.428 71.1452Z"
          fill="url(#paint2_linear_571_2390)"
        />
        <path
          d="M96.8434 87.2744C101.102 77.4438 112.565 70.7995 122.454 72.4328C124.193 72.7185 125.764 73.2485 127.153 73.9698C125.333 72.5708 123.076 71.5784 120.423 71.1385C110.534 69.5052 99.0717 76.1495 94.8128 85.9801C91.3011 94.0781 93.7824 101.804 100.296 105.189C95.3343 101.363 93.717 94.4592 96.8378 87.2674L96.8434 87.2744Z"
          fill="url(#paint3_linear_571_2390)"
        />
        <path
          d="M82.3756 81.8133C79.8443 85.0575 77.3025 88.2942 74.7713 91.5385C68.7051 99.2877 58.196 103.426 45.6439 101.769C24.2951 98.9564 5.134 80.4485 2.83615 60.4395C1.88721 52.1905 3.9607 44.9778 8.20867 39.5409L15.8129 29.8157C11.565 35.2526 9.49149 42.4653 10.4404 50.7143C12.7383 70.7233 31.8993 89.2312 53.2482 92.0435C65.8003 93.7011 76.3094 89.5625 82.3756 81.8133Z"
          fill="url(#paint4_linear_571_2390)"
        />
        <path
          d="M87.7559 60.9112C90.0537 80.9202 74.6064 94.8615 53.256 92.0401C31.9056 89.2186 12.746 70.7199 10.4482 50.7108C8.15791 30.6912 23.5977 16.7605 44.9466 19.5728C66.297 22.3943 85.458 40.9021 87.7559 60.9112Z"
          fill="url(#paint5_linear_571_2390)"
        />
        <path
          d="M76.8752 59.4692C78.5207 73.8421 67.4341 83.8597 52.0931 81.8369C36.7613 79.8125 22.983 66.5145 21.3375 52.1416C19.6905 37.7597 30.7877 27.7496 46.1196 29.774C61.4605 31.7969 75.2282 45.0873 76.8752 59.4692Z"
          fill="url(#paint6_linear_571_2390)"
        />
        <path
          d="M45.1322 33.0977C60.4732 35.1205 74.2409 48.4109 75.8878 62.7929C76.1798 65.3224 76.0658 67.7143 75.6139 69.9291C76.8364 66.8475 77.3211 63.3194 76.8815 59.46C75.2346 45.078 61.4669 31.7876 46.1259 29.7647C33.4875 28.0936 23.7384 34.5994 21.6163 44.9871C24.9662 36.5801 33.9147 31.6001 45.1398 33.0871L45.1322 33.0977Z"
          fill="url(#paint7_linear_571_2390)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_571_2390"
          x1="96.8097"
          y1="119.51"
          x2="136.471"
          y2="71.3427"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18C2DE" />
          <stop offset="1" stopColor="#DEF5F9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_571_2390"
          x1="92.5133"
          y1="112.678"
          x2="151.17"
          y2="26.1414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEF5F9" />
          <stop offset="1" stopColor="#18C2DE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_571_2390"
          x1="100.392"
          y1="104.113"
          x2="126.51"
          y2="72.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEF5F9" />
          <stop offset="1" stopColor="#18C2DE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_571_2390"
          x1="97.2405"
          y1="104.845"
          x2="125.743"
          y2="75.2838"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18C2DE" />
          <stop offset="1" stopColor="#DEF5F9" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_571_2390"
          x1="0.343654"
          y1="45.8153"
          x2="82.9518"
          y2="81.8313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#609399" />
          <stop offset="1" stopColor="#B1CCCF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_571_2390"
          x1="8.13198"
          y1="37.1413"
          x2="151.556"
          y2="84.3484"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B1CCCF" />
          <stop offset="1" stopColor="#609399" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_571_2390"
          x1="23.1499"
          y1="44.6931"
          x2="76.8459"
          y2="68.6111"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B1CCCF" />
          <stop offset="1" stopColor="#609399" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_571_2390"
          x1="20.8842"
          y1="40.6067"
          x2="73.2303"
          y2="68.4906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#609399" />
          <stop offset="1" stopColor="#B1CCCF" />
        </linearGradient>
        <clipPath id="clip0_571_2390">
          <rect width="148" height="129" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
